export default "__VITE_ASSET__ifI4UcPS__";